// Related Products functionality
document.addEventListener('DOMContentLoaded', function() {

  // Gestion du changement de variant
  const variantSelects = document.querySelectorAll('.variant-select');
  variantSelects.forEach(select => {
    select.addEventListener('change', function() {
      const selectedOption = this.options[this.selectedIndex];
      const price = parseInt(selectedOption.dataset.price);
      const comparePrice = parseInt(selectedOption.dataset.comparePrice);
      const variantId = selectedOption.value;
      const bestseller = selectedOption.dataset.bestseller;

      console.log('Changement variant:', { price, comparePrice, variantId, bestseller });

      // Mettre à jour le prix affiché
      const card = this.closest('.related-product-card');
      const priceElement = card.querySelector('.related-product-price');

      if (price && priceElement) {
        // Vider le contenu existant
        priceElement.innerHTML = '';

        // Formatage des prix
        const formattedPrice = new Intl.NumberFormat('fr-FR', {
          style: 'currency',
          currency: 'EUR'
        }).format(price / 100);

        if (comparePrice && comparePrice > price) {
          // Produit en réduction
          const formattedComparePrice = new Intl.NumberFormat('fr-FR', {
            style: 'currency',
            currency: 'EUR'
          }).format(comparePrice / 100);

          const discountPercentage = Math.round(((comparePrice - price) / comparePrice) * 100);

          priceElement.innerHTML = `
            <div class="related-product-price-top">
              <span class="price-discount">-${discountPercentage}%</span>
            </div>
            <div class="price-horizontal">
              <span class="price-sale">${formattedPrice}</span>
              <span class="price-compare">${formattedComparePrice}</span>
            </div>
          `;
        } else {
          // Prix normal
          priceElement.innerHTML = `<span class="price-regular">${formattedPrice}</span>`;
        }
      }

      // Mettre à jour l'ID du variant dans le form
      const variantIdInput = card.querySelector('.variant-id');
      if (variantIdInput) {
        variantIdInput.value = variantId;
      }

      // Mettre à jour le statut du bouton
      const addButton = card.querySelector('.related-product-btn');
      if (selectedOption.disabled) {
        addButton.disabled = true;
        addButton.textContent = 'Épuisé';
      } else {
        addButton.disabled = false;
        addButton.textContent = 'Ajouter';
      }
    });
  });

  // Gestion de l'ajout au panier
  const relatedProductForms = document.querySelectorAll('.related-product-form');
  relatedProductForms.forEach(form => {
    form.addEventListener('submit', function(e) {
      e.preventDefault();

      const button = this.querySelector('.related-product-btn');
      const variantId = this.querySelector('input[name="id"]').value;
      const quantity = this.querySelector('input[name="quantity"]').value;

      if (!variantId || button.disabled) {
        return;
      }

      // État de loading
      button.classList.add('loading');
      button.disabled = true;

      // Vérifier que variantId est valide
      if (!variantId || variantId === 'undefined' || variantId === '') {
        console.error('Variant ID invalide:', variantId);
        return;
      }

      // Envoyer la requête
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: variantId,
          quantity: parseInt(quantity)
        })
      })
      .then(response => {
        console.log('Response status:', response.status);
        return response.json();
      })
      .then(data => {
        console.log('Response data:', data);
        if (data.status && data.status === 422) {
          throw new Error(data.description);
        }

        // Succès - reproduire le comportement d'ajout normal

        // 1. Mettre à jour le compteur du panier
        updateCartCount();

        // 2. Forcer la mise à jour du drawer avec plusieurs méthodes
        setTimeout(() => {
          console.log('Début de la mise à jour du drawer...');

          const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
          console.log('Cart element trouvé:', cart);

          if (cart) {
            console.log('Méthodes disponibles:', {
              getSectionsToRender: typeof cart.getSectionsToRender,
              renderContents: typeof cart.renderContents,
              open: typeof cart.open
            });

            // Méthode 1: Essayer avec getSectionsToRender
            if (typeof cart.getSectionsToRender === 'function') {
              const sectionsToRender = cart.getSectionsToRender().map(section => section.id);
              console.log('Sections à rendre:', sectionsToRender);

              const sectionsUrl = `${window.location.pathname}?sections=${sectionsToRender.join(',')}`;
              console.log('URL des sections:', sectionsUrl);

              fetch(sectionsUrl)
                .then(response => response.json())
                .then(sections => {
                  console.log('Sections reçues:', sections);

                  if (typeof cart.renderContents === 'function') {
                    console.log('Appel de renderContents avec:', { id: variantId, sections });
                    cart.renderContents({
                      id: variantId,
                      sections: sections
                    });

                    // Forcer la suppression de la classe is-empty et gérer l'ouverture
                    setTimeout(() => {
                      cart.classList.remove('is-empty');
                      const drawerInner = cart.querySelector('.drawer__inner');
                      if (drawerInner) {
                        drawerInner.classList.remove('is-empty');
                      }
                      console.log('Classes is-empty supprimées');

                      // Forcer l'ouverture du drawer après la mise à jour
                      if (!cart.classList.contains('active')) {
                        if (typeof cart.open === 'function') {
                          cart.open();
                        } else {
                          cart.classList.add('active');
                          document.body.classList.add('overflow-hidden');
                        }
                      }
                    }, 100);
                  }
                })
                .catch(error => {
                  console.error('Erreur méthode 1:', error);
                  tryMethod2();
                });
            } else {
              tryMethod2();
            }

            // Méthode 2: Mise à jour manuelle
            function tryMethod2() {
              console.log('Essai méthode 2: mise à jour manuelle');

              fetch('/cart?view=drawer')
                .then(response => response.text())
                .then(html => {
                  console.log('HTML reçu, longueur:', html.length);

                  const parser = new DOMParser();
                  const doc = parser.parseFromString(html, 'text/html');
                  const newCartContent = doc.querySelector('#CartDrawer');
                  const currentCartContent = document.querySelector('#CartDrawer');

                  console.log('Nouveau contenu trouvé:', !!newCartContent);
                  console.log('Contenu actuel trouvé:', !!currentCartContent);

                  if (newCartContent && currentCartContent) {
                    currentCartContent.innerHTML = newCartContent.innerHTML;
                    console.log('Contenu mis à jour manuellement');

                    // Supprimer les classes is-empty
                    cart.classList.remove('is-empty');
                    const drawerInner = cart.querySelector('.drawer__inner');
                    if (drawerInner) {
                      drawerInner.classList.remove('is-empty');
                    }
                  }

                  // Ouvrir le drawer
                  if (typeof cart.open === 'function') {
                    cart.open();
                  } else {
                    const cartIcon = document.querySelector('#cart-icon-bubble');
                    if (cartIcon) {
                      cartIcon.click();
                    }
                  }
                })
                .catch(error => {
                  console.error('Erreur méthode 2:', error);
                  // Fallback final
                  const cartIcon = document.querySelector('#cart-icon-bubble');
                  if (cartIcon) {
                    cartIcon.click();
                  }
                });
            }
          } else {
            console.log('Aucun cart drawer/notification trouvé');
            const cartIcon = document.querySelector('#cart-icon-bubble');
            if (cartIcon) {
              cartIcon.click();
            }
          }
        }, 200);

        // 3. Déclencher tous les événements nécessaires
        document.dispatchEvent(new CustomEvent('cart:changed'));
        document.dispatchEvent(new CustomEvent('cart:updated'));
        document.dispatchEvent(new CustomEvent('cart:refresh'));

        // 4. Feedback visuel temporaire
        button.textContent = 'Ajouté ✓';
        button.style.background = '#28a745';

        setTimeout(() => {
          button.classList.remove('loading');
          button.disabled = false;
          button.textContent = 'Ajouter';
          button.style.background = '';
        }, 2000);

      })
      .catch(error => {
        console.error('Erreur lors de l\'ajout au panier:', error);

        // Afficher l'erreur
        button.textContent = 'Erreur';
        button.style.background = '#dc3545';

        setTimeout(() => {
          button.classList.remove('loading');
          button.disabled = false;
          button.textContent = 'Ajouter';
          button.style.background = '';
        }, 2000);
      });
    });
  });

});

// Fonction pour ouvrir le cart drawer comme un ajout normal
function openCartDrawer() {
  // Chercher et déclencher tous les mécanismes possibles d'ouverture

  // 1. Cart drawer element
  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer && typeof cartDrawer.open === 'function') {
    cartDrawer.open();
    return true;
  }

  // 2. Cart notification
  const cartNotification = document.querySelector('cart-notification');
  if (cartNotification && typeof cartNotification.open === 'function') {
    cartNotification.open();
    return true;
  }

  // 3. Simuler un clic sur l'icône du panier
  const cartTriggers = [
    '[data-cart-drawer]',
    '.cart-link',
    '.header__icon--cart',
    '[aria-controls="cart-drawer"]',
    '.cart-count-bubble'
  ];

  for (const selector of cartTriggers) {
    const trigger = document.querySelector(selector);
    if (trigger) {
      trigger.click();
      return true;
    }
  }

  // 4. Déclencher événements custom pour les drawers
  document.dispatchEvent(new CustomEvent('drawer:open', { detail: { drawer: 'cart' } }));

  return false;
}

// Fonction pour mettre à jour le compteur du panier
function updateCartCount() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      // Mettre à jour tous les compteurs possibles
      const selectors = ['.cart-count', '.cart-count-bubble', '[data-cart-count]', '.header__icon--cart .visually-hidden'];

      selectors.forEach(selector => {
        const elements = document.querySelectorAll(selector);
        elements.forEach(element => {
          if (element.tagName === 'SPAN' || element.hasAttribute('data-cart-count')) {
            element.textContent = cart.item_count;
          }
        });
      });

      // Mettre à jour l'attribut aria-label si présent
      const cartButton = document.querySelector('.header__icon--cart');
      if (cartButton) {
        cartButton.setAttribute('aria-label', `Panier (${cart.item_count})`);
      }
    })
    .catch(error => {
      console.error('Erreur lors de la mise à jour du compteur:', error);
    });
}